var _line, _rect, _path, _path2, _g, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuInterior(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.0001,
    y1: 21.6667,
    x2: 25.0001,
    y2: 25,
    stroke: "#5C5B5A",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 22.5,
    width: 5,
    height: 9.16667,
    fill: "#FF791C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0942 7.91709C12.2841 7.181 12.9479 6.66663 13.7081 6.66663H26.292C27.0522 6.66663 27.716 7.181 27.9059 7.91709L31.1295 20.4171C31.4016 21.472 30.6051 22.5 29.5157 22.5H10.4844C9.39501 22.5 8.59849 21.472 8.87054 20.4171L12.0942 7.91709Z",
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 24,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0942 7.91709C12.2841 7.181 12.9479 6.66663 13.7081 6.66663H26.292C27.0522 6.66663 27.716 7.181 27.9059 7.91709L31.1295 20.4171C31.4016 21.472 30.6051 22.5 29.5157 22.5H10.4844C9.39501 22.5 8.59849 21.472 8.87054 20.4171L12.0942 7.91709Z",
    fill: "#D1CFCD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8334 25.8334L-0.833252 -6.66663V25.8334H30.8334Z",
    fill: "#C6C6C6"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 30.8334,
    width: 15,
    height: 2.5,
    rx: 1.25,
    fill: "#FF791C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuInterior);
export default __webpack_public_path__ + "static/media/wikiMenuInterior.064bb8d2bf081d3914a826f20af3b463.svg";
export { ForwardRef as ReactComponent };